const TYPING_DELAY = 200;
const ACTIVE_CLASS = 'is-active';
const OPEN_CLASS = 'has-results-open';
const LOADING_CLASS = 'is-loading';
const OPTION_SELECTOR = '.product-search-item, .product-search-all';

export default class SearchEventHandler {
    /**
     * @param {function(): ProductSearchRepository} createRepository
     */
    constructor(createRepository) {
        this.createRepository = createRepository;
    }

    /**
     * @returns this
     */
    addLiveProductSearch() {
        if (typeof orchid_store_kc_product_search === 'undefined') {
            return this;
        }
        jQuery('form.woocommerce-product-search').each((index, form) => {
            this.#addLiveProductSearchToForm(jQuery(form), index);
        });
        return this;
    }

    #addLiveProductSearchToForm($form, index) {
        const $field = $form.find('.search-field');
        const $entry = $form.find('.custom-search-entry');
        if (!$field.length || !$entry.length) {
            return;
        }

        const repository = this.createRepository();
        const resultsId = 'product-search-results-' + index;
        const $results = jQuery('<div class="product-search-results" role="listbox" hidden></div>').attr('id', resultsId);
        $entry.append($results);
        $field.attr({
            'autocomplete': 'off',
            'autocapitalize': 'off',
            'spellcheck': 'false',
            'enterkeyhint': 'search',
            'role': 'combobox',
            'aria-autocomplete': 'list',
            'aria-expanded': 'false',
            'aria-controls': resultsId,
            'aria-label': $field.attr('placeholder')
        });

        let typingTimer = null;
        let shownTerm = '';

        const close = () => {
            $results.prop('hidden', true);
            $results.find('.' + ACTIVE_CLASS).removeClass(ACTIVE_CLASS);
            $form.removeClass(OPEN_CLASS);
            $field.attr('aria-expanded', 'false').removeAttr('aria-activedescendant');
        };

        const open = () => {
            if (shownTerm === '' || shownTerm !== this.#getTerm($field)) {
                return;
            }
            $results.prop('hidden', false);
            $form.addClass(OPEN_CLASS);
            $field.attr('aria-expanded', 'true');
        };

        const reset = () => {
            clearTimeout(typingTimer);
            repository.abort();
            shownTerm = '';
            $form.removeClass(LOADING_CLASS);
            close();
        };

        const search = (term) => {
            $form.addClass(LOADING_CLASS);
            repository.getHtml(term)
                .then((html) => {
                    if (term !== this.#getTerm($field)) {
                        return;
                    }
                    $results.html(html).scrollTop(0);
                    $results.find(OPTION_SELECTOR).each((optionIndex, option) => {
                        jQuery(option).attr({'role': 'option', 'id': resultsId + '-option-' + optionIndex});
                    });
                    shownTerm = term;
                    $form.removeClass(LOADING_CLASS);
                    open();
                })
                .catch((error) => {
                    if (error && error.statusText === 'abort') {
                        return;
                    }
                    reset();
                });
        };

        $field.on('input', () => {
            const term = this.#getTerm($field);
            clearTimeout(typingTimer);
            if (term.length < orchid_store_kc_product_search.min_term_length) {
                reset();
                return;
            }
            if (term === shownTerm) {
                open();
                return;
            }
            typingTimer = setTimeout(() => search(term), TYPING_DELAY);
        });

        $field.on('focus click', open);

        $field.on('keydown', (event) => {
            if (event.key === 'Escape') {
                close();
                return;
            }
            if ($results.prop('hidden')) {
                return;
            }
            if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
                event.preventDefault();
                this.#moveActiveOption($field, $results, event.key === 'ArrowDown' ? 1 : -1);
                return;
            }
            const $activeOption = $results.find('.' + ACTIVE_CLASS);
            if (event.key === 'Enter' && $activeOption.length) {
                event.preventDefault();
                window.location.href = $activeOption.attr('href');
            }
        });

        jQuery(document).on('click focusin', (event) => {
            if (!$form[0].contains(event.target)) {
                close();
            }
        });
    }

    #getTerm($field) {
        return String($field.val()).trim().replace(/\s+/g, ' ');
    }

    #moveActiveOption($field, $results, step) {
        const $options = $results.find(OPTION_SELECTOR);
        if (!$options.length) {
            return;
        }
        const activeIndex = $options.index($options.filter('.' + ACTIVE_CLASS));
        $options.removeClass(ACTIVE_CLASS);

        const nextIndex = activeIndex + step;
        if (nextIndex < 0 || nextIndex >= $options.length) {
            $field.removeAttr('aria-activedescendant');
            return;
        }
        const $nextOption = $options.eq(nextIndex).addClass(ACTIVE_CLASS);
        $field.attr('aria-activedescendant', $nextOption.attr('id'));
        $nextOption[0].scrollIntoView({block: 'nearest'});
    }
}
